import { Popover, Typography } from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import { MaxLessonsPerDayForm } from 'entities/max-lessons-per-day';
import type { MaxLessonsPerDay } from 'shared/api';
import { useMaxLessonsPopup } from '../model';
import styles from '../../../styles.module.scss';

interface MaxLessonsPopupProps {
  configuration: MaxLessonsPerDay | null;
}

export const MaxLessonsPopup = ({ configuration }: MaxLessonsPopupProps) => {
  const {
    state: { form },
  } = useMaxLessonsPopup(configuration);

  const content =
    configuration == null ? (
      <Typography.Text type="secondary">Выберите конфигурацию в списке</Typography.Text>
    ) : (
      <>
        <Typography.Text strong>{configuration.name}</Typography.Text>
        <MaxLessonsPerDayForm form={form} readOnly hideTitle />
      </>
    );

  return (
    <Popover trigger="click" content={content} placement="right">
      <ExclamationCircleOutlined
        className={styles.maxLessonsPreviewIcon}
        title="Просмотр параметров по параллелям"
      />
    </Popover>
  );
};
